module.exports = __webpack_public_path__ + "img/007.63ce9ddd.png";